import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'AiraLabelPipe' })
export class AiraLabelPipe implements PipeTransform {

  transform(inputString) {
    return inputString.replace(/Aira\d+/g, '');
  }
}
